/**
 * Raccolta delle configurazioni del calcolatore.
 *
 * Fa una cosa sola: quando il visitatore ha finito di configurare,
 * manda la configurazione al Worker. Non mostra niente, non chiede niente,
 * non tocca una virgola di cio che vede Google.
 *
 * Tre difese pensate sul comportamento reale di script.js:
 *  - non salva mai la configurazione iniziale se il visitatore non ha
 *    toccato nulla (altrimenti ogni rimbalzo falserebbe le medie)
 *  - non legge il prezzo mentre l'animazione di script.js lo sta ancora
 *    facendo salire (altrimenti salverebbe un numero intermedio)
 *  - non puo rompere la pagina: tutto dentro try/catch, nessuna eccezione esce
 */
(function () {
  var ENDPOINT = 'https://dogio-raccolta.thewarriortrader.workers.dev/';
  var ATTESA = 2500;    // ms di immobilita prima di considerare finita la configurazione
  var ANIMAZIONE = 600; // ms: script.js anima il prezzo su 500ms, teniamo un margine
  var TETTO = 10;       // configurazioni intermedie salvate per visita

  try {
    var timer = null, ultimoInvio = '', inviati = 0;
    var ultimoTocco = 0, interagito = false;

    function sessione() {
      try {
        var k = 'dogio_s', v = sessionStorage.getItem(k);
        if (!v) { v = Math.random().toString(36).slice(2, 10) + Date.now().toString(36); sessionStorage.setItem(k, v); }
        return v;
      } catch (e) { return null; }
    }

    function val(id) { var e = document.getElementById(id); return e ? e.value : null; }
    function scelto(n) { var e = document.querySelector('input[name="' + n + '"]:checked'); return e ? e.value : null; }

    function raccogli() {
      var p = document.getElementById('prezzo');
      return {
        tatuatore:    val('tatuatore'),
        stile:        val('stile'),
        colore:       scelto('colore'),
        altezza_cm:   val('altezza'),
        larghezza_cm: val('larghezza'),
        dettaglio:    scelto('dettaglio'),
        prezzo_eur:   p ? parseFloat(String(p.textContent).replace(/[^\d.,]/g, '').replace(',', '.')) : null,
        dispositivo:  window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop',
        provenienza:  document.referrer ? document.referrer.slice(0, 60) : null,
        percorso:     location.pathname,
        sessione:     sessione()
      };
    }

    function manda(immediato) {
      try {
        if (!interagito) return;                                       // il default intatto non e un dato
        if (immediato && (Date.now() - ultimoTocco) < ANIMAZIONE) return; // prezzo ancora in animazione
        var d = raccogli();
        if (d.prezzo_eur === null || isNaN(d.prezzo_eur)) return;
        var corpo = JSON.stringify(d);
        if (corpo === ultimoInvio) return;                             // niente doppioni
        if (!immediato && inviati >= TETTO) return;                    // il tetto non vale per l'ultimo invio
        ultimoInvio = corpo; inviati++;
        if (navigator.sendBeacon) {
          navigator.sendBeacon(ENDPOINT, new Blob([corpo], { type: 'text/plain;charset=UTF-8' }));
        } else {
          fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: corpo, keepalive: true }).catch(function () {});
        }
      } catch (e) {}
    }

    function tocco() {
      interagito = true;
      ultimoTocco = Date.now();
      clearTimeout(timer);
      timer = setTimeout(function () { manda(false); }, ATTESA);
    }

    function accendi() {
      try {
        ['tatuatore', 'stile', 'altezza', 'larghezza'].forEach(function (id) {
          var e = document.getElementById(id);
          if (e) { e.addEventListener('change', tocco); e.addEventListener('input', tocco); }
        });
        var r = document.querySelectorAll('input[name="colore"], input[name="dettaglio"]');
        for (var i = 0; i < r.length; i++) r[i].addEventListener('change', tocco);

        window.addEventListener('pagehide', function () { manda(true); });
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'hidden') manda(true);
        });
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', accendi);
    } else {
      accendi();
    }
  } catch (e) {}
})();
